import { apiClient } from '@/api/client';
import { createEntityMutationHook } from '@/hooks/useEntityMutations';
import { queryKeys } from '@/lib/queryKeys';
import { AppVersion, AppVersionFormData } from '@/pages/app-versions/types';

export const useAppVersionMutations = createEntityMutationHook<
  AppVersionFormData,
  AppVersion
>({
  entityName: 'App Version',
  basePath: '/app-versions',
  queryKeys: [queryKeys.ADMIN_APP_VERSIONS],
  getId: appVersion => appVersion.id!,
  getDeleteConfirmMessage: appVersion =>
    `Are you sure you want to delete the ${appVersion.platform} app version?`,
  createFn: async data => {
    const response = await apiClient.POST('/admin/app-versions', {
      body: {
        platform: data.platform,
        minimumVersion: data.minimumVersion,
        latestVersion: data.latestVersion,
        forceUpdate: data.forceUpdate,
        updateMessage: data.updateMessage,
        appStoreUrl: data.appStoreUrl,
        enabled: data.enabled,
      },
    });
    if (response.error) throw new Error('Failed to create app version');
    return response.data as AppVersion;
  },
  updateFn: async data => {
    const response = await apiClient.PUT('/admin/app-versions/{id}', {
      params: { path: { id: data.id } },
      body: {
        minimumVersion: data.minimumVersion,
        latestVersion: data.latestVersion,
        forceUpdate: data.forceUpdate,
        updateMessage: data.updateMessage,
        appStoreUrl: data.appStoreUrl,
        enabled: data.enabled,
      },
    });
    if (response.error) throw new Error('Failed to update app version');
    return response.data as AppVersion;
  },
  deleteFn: async id => {
    const response = await apiClient.DELETE('/admin/app-versions/{id}', {
      params: { path: { id } },
    });
    if (response.error) throw new Error('Failed to delete app version');
  },
});
